import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgEMailvoorkeuren = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FED27A"
      d="M35 10.21H5v13h30z"
    />
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="m5 10.21 15 10 15-10v20H5z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgEMailvoorkeuren);

export default ForwardRef;
